//2022.6までIE対応が必要。それ以降は外しでOK
import "core-js/stable";
import "regenerator-runtime/runtime";

import UI from "./common/ui";
import Modal from "./common/modal";
import Util from "./common/util/util.es6";

//ユーティリティ系処理
const util = new Util();
const ui = new UI();
const modal = new Modal();
